<template>
<div class="el-main">
  <div class="card"
       v-show="currentCardId == 'edu-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>学歴を入力</h2>
        <p>「自動入力」を使うと、入学・卒業年度を自動で計算できます</p>
        <el-checkbox v-model="formatData.notDisplayIjyo">【以上】を表示しない</el-checkbox>
      </div>
      <div class="card-content-list">
        <div class="add-item">
          <div class="edu-history-action">
            <auto-educational-backgrounds v-on:create-educational-background="setEducationalBackgrounds"
                                          :year="basicData.birthYear"
                                          :month="basicData.birthMonth"
                                          :day="basicData.birthDay"></auto-educational-backgrounds>
            <div class="button-reset">
              <el-button v-if="formatData.educationalHistories && formatData.educationalHistories.length > 1"
                         @click="$modal.show('educational-reset')">リセット</el-button>
            </div>
            <modal name="educational-reset"
                   :adaptive="true"
                   :scrollable="true"
                   height="auto">
              <div class="v--modal-close-top">
                <el-button @click="$modal.hide('educational-reset');"
                           icon="el-icon-close"
                           type="text"></el-button>
              </div>
              <div class="title">学歴リセット</div>
              <span>入力されている学歴をすべて削除します。よろしいですか？</span>

              <div class="text-left">
                <el-button type="primary"
                           @click="$modal.hide('educational-reset');resetEducationalBackgrounds()">リセットする</el-button>
                <el-button @click="$modal.hide('educational-reset')">リセットしない</el-button>
              </div>
            </modal>

          </div>
        </div>
        <div class="edit-form-item" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
          <div class="item-name">卒業予定</div>
          <div class="item-body">
            <el-select v-model="formatData.gradeYear"
              placeholder="選択してください">
              <el-option v-for="item in gradeYearOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="edit-form-list">
          <transition-group name="fade"
                            tag="div">
            <history-item v-on:add-history-item="addEducationalHistory"
                          v-on:delete-history-item="deleteEducationalHistory"
                          v-on:move-history-item="moveEducationalHistory"
                          v-for="(item, index) in formatData.educationalHistories"
                          @click.native="activateHistoryItem(item.uuid)"
                          :item="item"
                          :length="formatData.educationalHistories.length"
                          :index="index"
                          :key="item.uuid"
                          :id="item.uuid"
                          :class="{'active': activeHistoryItem == item.uuid}"
                          :minYear="basicData.birthYear"
                          :ref="'EducationalHistory_' + index"
                          :createDate="formatData.createDate"
                          :descriptionPlaceholder="'学歴を入力'"
                          :descriptionMaxLength="descriptionMaxLength"></history-item>
          </transition-group>
          <div class="add-list-item">
            <el-button icon="el-icon-plus"
                       circle
                       type="success"
                       @click="addEducationalHistory()"></el-button>
          </div>
        </div>
        <div class="attention-limit column"
             v-if="previewErrors.eduJobHistory">
          <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
        </div>
      </div>
    </div>
  </div>

  <div class="card"
       v-show="currentCardId == 'job-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職歴を入力</h2>
        <p>「自動入力」を使うと、入社・退社表記を自動で作成できます。</p>
        <el-checkbox v-model="formatData.notDisplayIjyo">【以上】を表示しない</el-checkbox>
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <div class="add-item">
            <auto-job-histories v-on:job-histories-created="setJobHistories"
                                :birth-year="basicData.birthYear"
                                :birth-month="basicData.birthMonth"
                                :birth-day="basicData.birthDay"></auto-job-histories>
            <div class="button-reset">
              <el-button type=""
                         v-if="formatData.jobHistories && formatData.jobHistories.length > 1"
                         @click="$modal.show('job-reset')">リセット</el-button>
            </div>
            <modal name="job-reset"
                   :adaptive="true"
                   :scrollable="true"
                   height="auto">
              <div class="v--modal-close-top">
                <el-button @click="$modal.hide('job-reset');"
                           icon="el-icon-close"
                           type="text"></el-button>
              </div>
              <div class="title">職歴リセット</div>
              <span>現在入力されている職歴をすべて削除します。よろしいですか？</span>
              <div>
                <el-button type="primary"
                           @click="$modal.hide('job-reset');resetJobHistories()">リセットする</el-button>
                <el-button @click="$modal.hide('job-reset')">リセットしない</el-button>
              </div>
            </modal>
          </div>
          <transition-group name="fade"
                            tag="div">
            <history-item v-on:add-history-item="addJobHistory"
                          v-on:delete-history-item="deleteJobHistory"
                          v-on:move-history-item="moveJobHistory"
                          v-for="(item, index) in formatData.jobHistories"
                          @click.native="activateHistoryItem(item.uuid)"
                          :item="item"
                          :length="formatData.jobHistories.length"
                          :index="index"
                          :key="item.uuid"
                          :id="item.uuid"
                          :class="{'active': activeHistoryItem == item.uuid}"
                          :ref="'JobHistory_' + index"
                          :minYear="basicData.birthYear"
                          :createDate="formatData.createDate"
                          :descriptionPlaceholder="'職歴を入力'"
                          :descriptionMaxLength="descriptionMaxLength"></history-item>
          </transition-group>
          <div class="add-list-item">
            <el-button icon="el-icon-plus"
                       circle
                       type="success"
                       @click="addJobHistory()"></el-button>
          </div>
          <div class="attention-limit column"
               v-if="previewErrors.eduJobHistory">
            <i class="el-icon-warning"></i>&ensp;{{ previewErrors.eduJobHistory }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card"
       v-show="currentCardId == 'license-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>免許・資格を入力</h2>
        <p>主要な免許・資格は例文から選ぶことができます</p>
      </div>
      <div class="card-content-list">
        <div class="add-item">
          <el-button @click="$modal.show('license-dialog');"
                     type="success">例文から追加</el-button>
          <modal name="license-dialog"
                 :adaptive="true"
                 :scrollable="true"
                 height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('license-dialog');"
                         icon="el-icon-close"
                         type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.license"
                  v-on:click="addLicenseHistory(null, {description:item}); $modal.hide('license-dialog');"
                  :key="index">
                <div class="title">{{ index }}</div>
                <div class="body"
                     v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('license-dialog');">閉じる</el-button>
            </div>
          </modal>
        </div>
        <div class="edit-form-list">
          <transition-group name="fade"
                            tag="div">
            <history-item v-on:add-history-item="addLicenseHistory"
                          v-on:delete-history-item="deleteLicenseHistory"
                          v-on:move-history-item="moveLicenseHistory"
                          v-for="(item, index) in formatData.licenseHistories"
                          @click.native="activateHistoryItem(item.uuid)"
                          :item="item"
                          :length="formatData.licenseHistories.length"
                          :index="index"
                          :key="item.uuid"
                          :id="item.uuid"
                          :class="{'active': activeHistoryItem == item.uuid}"
                          :ref="'LicenseHistory_' + index"
                          :minYear="basicData.birthYear"
                          :createDate="formatData.createDate"
                          :descriptionPlaceholder="'免許・資格を入力'"
                          :descriptionMaxLength="descriptionMaxLength"></history-item>
          </transition-group>
          <div class="add-list-item">
            <el-button icon="el-icon-plus"
                       circle
                       type="success"
                       @click="addLicenseHistory()"></el-button>
          </div>
          <div class="attention-limit column"
               v-if="previewErrors.licenseHistory">
            <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card"
       v-show="currentCardId == 'reason'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>志望動機を入力</h2>
        <p>{{ reasonLabel }}</p>
      </div>

      <div class="add-item">
        <el-button @click="$modal.show('reason-dialog')"
                   type="success">例文から追加</el-button>
      </div>

      <div class="card-content">
        <modal name="reason-dialog"
               :adaptive="true"
               :scrollable="true"
               height="auto">
          <div class="v--modal-close-top">
            <el-button @click="$modal.hide('reason-dialog');"
                       icon="el-icon-close"
                       type="text"></el-button>
          </div>
          <div class="title">例文を選ぶ</div>
          <div class="description">
            <p>選択した例文が追加されます。</p>
            <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
          </div>
          <ul class="example-sentence">
            <li v-for="(item, index) in exampleSentences.reason"
                v-on:click="formatData.reason=item.replace(/<br>/ig, '\n');$modal.hide('reason-dialog')"
                :key="index">
              <div class="title">{{ index }}</div>
              <div class="body"
                   v-html="item"></div>
            </li>
          </ul>
          <div class="text-right">
            <el-button @click="$modal.hide('reason-dialog')">閉じる</el-button>
          </div>
        </modal>
        <el-input type="textarea"
                  v-model="formatData.reason"
                  :autosize="{minRows: textareaMinRows, maxRows: 15}"></el-input>
        <div class="attention-limit character"
             v-if="previewErrors.reason">
          <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        </div>
      </div>
    </div>
  </div>

  <div class="card"
       v-show="currentCardId == 'reasonNew'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>自己PRを入力</h2>
        <p>{{ reasonLabel }}</p>
      </div>

      <div class="add-item">
        <el-button @click="$modal.show('reason-dialog')"
                   type="success">例文から追加</el-button>
      </div>

      <div class="card-content">
        <modal name="reason-dialog"
               :adaptive="true"
               :scrollable="true"
               height="auto">
          <div class="v--modal-close-top">
            <el-button @click="$modal.hide('reason-dialog');"
                       icon="el-icon-close"
                       type="text"></el-button>
          </div>
          <div class="title">例文を選ぶ</div>
          <div class="description">
            <p>選択した例文が追加されます。</p>
            <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
          </div>
          <ul class="example-sentence">
            <li v-for="(item, index) in exampleSentences.reason"
                v-on:click="formatData.reasonNew+=item.replace(/<br>/ig, '\n') + '\n';$modal.hide('reason-dialog')"
                :key="index">
              <div class="title">{{ index }}</div>
              <div class="body"
                   v-html="item"></div>
            </li>
          </ul>
          <div class="text-right">
            <el-button @click="$modal.hide('reason-dialog')">閉じる</el-button>
          </div>
        </modal>
        <el-input type="textarea"
                  v-model="formatData.reasonNew"
                  :autosize="{minRows: textareaMinRows, maxRows: 15}"></el-input>
        <div class="attention-limit character"
             v-if="previewErrors.reasonNew">
          <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        </div>
      </div>
    </div>
  </div>

  <div class="card"
       v-show="currentCardId == 'others'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>通勤時間ほか</h2>
        <p>通勤時間や扶養家族などを入力します</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div class="edit-form-item"
               v-if="optionItems.commuteDescription & this.formatId != 'rirekisho_job_new'">
            <div class="item-name">通勤手段<small>（電車・バス・自家用車など）</small></div>
            <div class="item-body">
              <el-input class="input-md"
                        type="textarea"
                        placeholder="電車（JR◯◯線）"
                        v-model="formatData.commuteDescription"
                        :autosize="{minRows: 1, maxRows: 2}">
              </el-input>
              <!--{{ $formLib.charCount(formatData.commuteDescription) }}-->
              <div class="error attention-limit character"
                   v-if="$formLib.charCount(formatData.commuteDescription) > 84">
                <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。
              </div>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">通勤時間</div>
            <div class="item-body">
              <el-input class="input-xs"
                        placeholder=""
                        title="時間"
                        type="number"
                        v-model="formatData.commuteHours"></el-input> 時間
              <el-input class="input-xs"
                        type="number"
                        placeholder=""
                        title="分"
                        v-model="formatData.commuteMinutes"></el-input> 分
            </div>

            <div class="item-name">扶養家族（配偶者を除く）</div>
            <div class="item-body">
              <el-input class="input-xs"
                        placeholder=""
                        title="扶養家族の人数"
                        type="number"
                        v-model="formatData.spouseNumber"></el-input> 人
            </div>
            <div class="item-name">配偶者</div>
            <div class="item-body">
              <el-radio v-model="formatData.hasSpouse"
                        :label="true"> あり</el-radio>
              <el-radio v-model="formatData.hasSpouse"
                        :label="false"> なし</el-radio>
            </div>
            <div class="item-name">配偶者の扶養義務</div>
            <div class="item-body">
              <el-radio v-model="formatData.underDutyToSupport"
                        :label="true">あり</el-radio>
              <el-radio v-model="formatData.underDutyToSupport"
                        :label="false">なし</el-radio>
            </div>
            <br>
            <div class="item-name" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">あなたは留学生ですか。</div>
            <div class="item-body" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
              <el-radio v-model="formatData.foreignStudent"
                        :label="true">はい</el-radio>
              <el-radio v-model="formatData.foreignStudent"
                        :label="false">いいえ</el-radio>
            </div>
            <el-checkbox v-model="formatData.notDisplayRecommend">紹介・推薦を表示しない</el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card"
       v-show="currentCardId == 'requests'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>本人希望欄を入力</h2>
        <p>給与・職種・勤務時間・勤務地などの希望を入力します（任意）</p>
      </div>
      <div class="add-item">
        <el-button @click="$modal.show('request-dialog')"
                   type="success">例文から追加</el-button>
      </div>
      <div class="card-content">
        <div class="edit-form-item">
          <div class="item-name">現在の年収</div>
          <div class="item-body">
            <el-input class="input-xs"
                      placeholder=""
                      title="現在の年収"
                      type="number"
                      v-model="formatData.nowNensyu"></el-input> 万円
          </div>
          <div class="item-name">希望年収</div>
          <div class="item-body">
            <el-input class="input-xs"
                      placeholder=""
                      title="希望年収"
                      type="number"
                      v-model="formatData.kibouNensyu"></el-input> 万円
          </div>
          <div class="item-name">※上記項目を入力した後、例文から追加ボタンをクリックして例文を選択すると自動的に反映されます。</div>
        </div>
        <br>
        <modal name="request-dialog"
               :adaptive="true"
               :scrollable="true"
               height="auto">
          <div class="v--modal-close-top">
            <el-button @click="$modal.hide('request-dialog');"
                       icon="el-icon-close"
                       type="text"></el-button>
          </div>
          <div class="title">例文を選ぶ</div>
          <div class="description">
            <p>選択した例文が追加されます。</p>
            <p class="attention">例文を選択すると、現在入力している文章は上書きされますのでご注意ください。</p>
          </div>
          <ul class="example-sentence">
            <li v-for="(item, index) in exampleSentences.request"
                v-on:click="formatData.request += item.replace(/<br>/ig, '\n').replace('OOO', formatData.nowNensyu).replace('XXX', formatData.kibouNensyu) + '\n';$modal.hide('request-dialog');"
                :key="index">
              <div class="title">{{ index }}</div>
              <div class="body"
                   v-html="item"></div>
            </li>
          </ul>
          <div class="text-right">
            <el-button @click="$modal.hide('request-dialog');">閉じる</el-button>
          </div>
        </modal>
        <el-input type="textarea"
                  :autosize="{minRows: 3, maxRows: 15}"
                  placeholder="給与・職種・勤務時間・勤務地など希望があれば入力"
                  v-model="formatData.request">
        </el-input>
        <div class="attention-limit character"
             v-if="previewErrors.request">
          <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        </div>
      </div>
    </div>
  </div>

  <div class="card"
       v-show="currentCardId == 'create-date'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>履歴書の作成日を入力</h2>
        <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form-list">
          <div class="create-date-action">
            <div class="action-item">
              <el-button class="button-block"
                         :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                         @click="formatData.createDate = $formLib.getToday()">今日の日付を入力</el-button>
            </div>
            <div class="action-item">
              <el-button class="button-block"
                         :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                         @click="formatData.createDate = $formLib.getTommorow()">明日の日付を入力</el-button>
            </div>
            <div class="action-item">
              <el-date-picker v-model="formatData.createDate"
                              type="date"
                              :clearable="false"
                              placeholder="選択してください"
                              :format="'yyyy年M月d日'"
                              ref="create_date">
              </el-date-picker>
            </div>
          </div>
        </div>
        <br>
        <div v-if="true">
          <el-collapse accordion v-model="activeName">
            <el-collapse-item name="1">
              <template slot="title" >
                <div class="yagitaku">
                  <span class="yagitaku_recommend">オススメ</span>印刷から郵送まであなたの代わりに！ヤギの宅配便サービス
                </div>
              </template>
              <div class="el-collapse-item__content">
                <p>就職または転職を考えている企業先に、あなたの代わりにヤギッシュが「履歴書」「送付状」「封筒」を印刷して郵送いたします。（職務経歴書は自由選択）<br>

                <div class="bnr_item create-date_bnr">
                  <div class="bnr_txt create-date_txt">
                    <el-button  
                        style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                        :disabled="!$deviceLib.isOnline ||!isSendYagiPostEnabled"
                        @click="$eventHub.$emit('send-special-post', formatId);">
                      <h3>ヤギの宅配便<span>をつかう</span></h3>
                    </el-button>          
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>

  <div class="card" v-show="currentCardId == 'output'" v-if="getMode != 'production1'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>ダウンロード</h2>
        <p>作成した履歴書をPDFでダウンロードします。<br>メール送信、コンビニ印刷、ダウンロードボタンを押下すると自動でバックアップされます。</p>
      </div>
      <div class="card-content">
        <div class="button-download-pdf">
          <h3 class="next_bnr">選択中のフォントはコレ！</h3>

          <p v-if="formatData.selFontStyle" :style="formatData.selFontStyle"
            style="text-align: center;"><el-button v-ripple
            plain
            @click="$eventHub.$emit('show-preview');"
            type="success"
            style="border-color:#555;color:#000;text-align: center;"
            id="preview-button-format-edit"><i class="el-icon-view"></i> {{formatData.selectedFontName}}</el-button></p>
          <p v-else
            style="text-align: center;"><el-button v-ripple
            plain
            @click="$eventHub.$emit('show-preview');"
            type="success"
            style="border-color:#555;color:#000;text-align: center;"
            id="preview-button-format-edit"><i class="el-icon-view"></i> デフォルト</el-button></p>
          <p class="bnr_note" style="text-align: center;">※プレビューで確認、再選択できます。</p>

          <div class="bnr_container">
            <div class="bnr_itemWrapper">
              <div class="bnr_item">
                <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便">
                <div class="bnr_txt">
                  <el-button  
                       style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                       :disabled="!$deviceLib.isOnline ||!isSendYagiPostEnabled"
                       @click="$eventHub.$emit('send-special-post', formatId);isSendYagiPostEnabled = false">
                    <p>履歴書送付は任せろメェ〜</p>
                    <br>
                    <h3>ヤギの宅配便<span>をつかう</span></h3>
                  </el-button>          
                </div>
              </div>
            </div>
            <div class="bnr_itemWrapper">
              <div class="bnr_item">
                <img src="/static/renew_img/print.png" alt="コンビニプリント">
                <div class="bnr_txt">
                  <el-button id="pdf-eprint-edit"
                            style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                            @click="$eventHub.$emit('show-preview-4conv')">
                          <p>面接に履歴書が必要？印刷だメェ〜ェ〜</p>
                          <br>
                          <h3>コンビニプリント<span>をつかう</span></h3>
                  </el-button>          
                </div>
              </div>
            </div>
            <div class="bnr_itemWrapper">
              <div class="bnr_item">
                <div class="bnr_txt txt">
                  <el-button id="pdf-mail-edit"
                            style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                            :disabled="!$deviceLib.isOnline ||!mailPdfEnabled"
                            @click="$eventHub.$emit('mail-PDF');mailPdfEnabled = false">
                          <p>登録したメアドに送るメェ〜</p>
                          <br>
                          <h3>PDFをメールで送る</h3>
                  </el-button>
                </div>
                <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
              </div>
            </div>
            <div class="bnr_itemWrapper">
              <div class="bnr_item">
                <div class="bnr_txt txt">
                  <el-button id="pdf-mail-edit"
                            style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                            :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                            @click="$eventHub.$emit('download-PDF');downloadPdfEnabled = false;">
                    <p>端末に保存するメェ〜</p>
                    <br>
                    <h3>PDFをダウンロードする</h3>
                  </el-button>
                </div>
                <p class="bnr_note">
                  <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget"
                    target="_blank"
                    rel="nofollow">※できない場合はこちら</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-content">
        <el-collapse v-model="downloadActiveCollapses">

          <el-collapse-item title="ヤギにはがきを渡す"  v-if="false"
                            name="postcard">
            <div><router-link id="footer-link-postcard"
                         :to="{name: 'postCard'}"><img src="/static/img/postcard/postyagi.svg" alt="郵便ヤギ"><br>ヤギや運営へのひとことメッセージをお待ちしています</router-link></div>
          </el-collapse-item>

          <el-collapse-item title="スマホから履歴書を印刷するには"
                            name="print">
            <div>GoogleドライブやDropboxなどのクラウドストレージを使用するか、Gmail経由で自分宛てにPDFを送ってデータを保存します。印刷は自宅のプリンタまたはコンビニ印刷などをご利用下さい。</div>
            <div v-if="!$firebase.isAuthenticated">コンビニ印刷のサービスご利用には、ログイン(無料)が必要になります。</div>
            <ul class="collapse-list" v-if="$firebase.isAuthenticated">
              <li>
                <a id="pdf-eprint-edit"
                          type="success"
                          style="cursor:pointer;"
                          :disabled="!$deviceLib.isOnline"
                          @click="$eventHub.$emit('show-preview-4conv')">
                  セブンイレブン・ファミリーマート・ローソンなど - eプリント
                </a>
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="他の端末から続きを書くには"
                            name="backup">
            <div>他の端末から続きを編集したい場合は、Googleアカウントでログインし「バックアップをとる」でデータを保存して続きを書くことができます。なお、会員登録していない状態でも、現在入力されている端末からであれば続きの入力ができます（ブラウザのデータを削除したり、端末を変更した場合はリセットされます）。</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'output'" v-else>
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>ダウンロード</h2>
        <p>作成した履歴書をPDFでダウンロードできます。<br>PDFをメールで送信、コンビニプリント、その場でダウンロードするのいずれかを選択すると、作成した履歴書が自動でバックアップされます。</p>
      </div>
      <div class="card-content">
        <div class="text-center fluffy">
          <your-yagi :your-yagi-class="{}"
                     :yagi-options="{dialogEnabled: false, rubyEnabled: false, messageEnabled: true, fixedMessage: 'さいごまでがんばった！'}"></your-yagi>
        </div>
        <div class="button-download-pdf">
          <h3>フォント </h3>
          <p v-if="formatData.selFontStyle" :style="formatData.selFontStyle"><el-button v-ripple
            plain
            @click="$eventHub.$emit('show-preview');"
            type="success"
            style="border-color:#555;color:#000"
            id="preview-button-format-edit"><i class="el-icon-view"></i> {{formatData.selectedFontName}}</el-button></p>
          <p v-else><el-button v-ripple
            plain
            @click="$eventHub.$emit('show-preview');"
            type="success"
            id="preview-button-format-edit"><i class="el-icon-view"></i> デフォルト</el-button></p>
          <div v-if="!$firebase.isAuthenticated">
            <a :href="'/login?frompage=' + this.formatId" ><img src="/static/renew_img/bnr/banner_not_login.png" style="text-align:center;width:100%"></a>
          </div>
          <div v-if="$firebase.isAuthenticated && getMode != 'production' && true"
               class="attention-logged-in">
            <p>ヤギの宅配便</p>
            <el-button id="send-marunage"
                       type="primary"
                       plain
                       class="button-block"
                       style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
                       :disabled="!$deviceLib.isOnline ||!isSendYagiPostEnabled"
                       @click="$eventHub.$emit('send-special-post', formatId);isSendYagiPostEnabled = false">
              <i class="el-icon-message"></i> ヤギの宅配便で履歴書を郵送する
            </el-button>
          </div>
          <div v-if="$firebase.isAuthenticated && true"
               class="attention-logged-in">
            <p>PDFをあなたのメール宛てに送ります。</p>
            <el-button id="pdf-mail-edit"
                       type="primary"
                       plain
                       class="button-block"
                       style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
                       :disabled="!$deviceLib.isOnline ||!mailPdfEnabled"
                       @click="$eventHub.$emit('mail-PDF');mailPdfEnabled = false">
              <i class="el-icon-message"></i> PDFをメールで送る
            </el-button>
            <p>バックアップデータはマイページで確認できます</p>
            <el-button class="button-block"  v-if="false"
                       :disabled="!$deviceLib.isOnline"
                       @click="$router.push({name: 'backupIndex'})"><i class="el-icon-upload"></i> バックアップ画面を開く</el-button>

          </div>
          <el-button id="pdf-download-edit"
                     v-if="$firebase.isAuthenticated && !true"
                     class="button-block animation"
                     type="primary"
                     target="_blank"
                     :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                     @click="$eventHub.$emit('download-PDF');downloadPdfEnabled = false;">
            <i class="el-icon-download"></i> ダウンロードする
          </el-button>
          <div v-if="false" class="attention-logged-in">
            <p style="color:red;">※現在コンビニプリント連携を一時的に停止しております。ご迷惑をおかけしており申し訳ございません。</p>
          </div>
          <div v-if="$firebase.isAuthenticated" class="attention-logged-in">
            <el-button id="pdf-eprint-edit"
                       type="success"
                       class="button-block"
                       @click="$eventHub.$emit('show-preview-4conv')">
              <i class="el-icon-printer"></i> コンビニで印刷する
            </el-button>
          </div>
          <div v-if="isMynabi"
               class="attention-logged-in">
            <el-button id="mynavi-back"
                       type="primary"
                       plain
                       class="button-block"
                       :disabled="!$deviceLib.isOnline"
                       onclick="location.href='https://tenshoku.mynavi.jp/knowhow/rirekisho?af=yagish'">
              【履歴書の書き方を見る】
            </el-button>
            <p class="addition">採用担当者のチェックポイント・送り方なども解説！</p>
          </div>
          <br/>
          <br/>
          <el-button id="pdf-download-edit"
                     v-if="$firebase.isAuthenticated && true"
                     class="button-block animation"
                     type="primary"
                     target="_blank"
                     style="background-color:#fce8ef;border-color:#f4a2be;color:#e3165c"
                     :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                     @click="$eventHub.$emit('download-PDF');downloadPdfEnabled = false;">
            <i class="el-icon-download"></i> ダウンロードする
          </el-button>
          <br>
          <div class="text-right" v-if="true">
              <a href="https://blog.yagish.jp/entry/2022/04/06/163828?utm_source=blogWidget"
                id="footer-link-eprint"
                class="external-link"
                target="_blank"
                rel="nofollow">ダウンロードできない方はこちら</a>
          </div>
          <div v-if="$firebase.isAuthenticated && !true"
               class="attention-logged-in">
            <p>PDFをあなたのメール宛てに送ります。</p>
            <el-button id="pdf-mail-edit"
                       type="primary"
                       plain
                       class="button-block"
                       :disabled="!$deviceLib.isOnline ||!mailPdfEnabled"
                       @click="$eventHub.$emit('mail-PDF');mailPdfEnabled = false">
              <i class="el-icon-message"></i> PDFをメールで送る
            </el-button>
            <p>入力したデータの引き継ぎにはバックアップをおすすめします</p>
            <el-button class="button-block"  v-if="false"
                       :disabled="!$deviceLib.isOnline"
                       @click="$router.push({name: 'backupIndex'})"><i class="el-icon-upload"></i> バックアップ画面を開く</el-button>

          </div>
          <div v-if="!$firebase.isAuthenticated"
               class="attention-not-logged-in">
            <p>ログインすると、他の端末からも続きを書けるようにデータをバックアップできます。<br/>また、「コンビニ印刷」のサービスをご利用いただけます。</p>
            <login-forms :is-plain-button="true" />
          </div>

          <div class="error"
               v-if="!$deviceLib.isOnline">現在オフラインのためダウンロードはご利用頂けません。ネットワークに繋げてからお試しください。
          </div>
        </div>
      </div>
      <div class="card-content">
        <el-collapse v-model="downloadActiveCollapses">

          <el-collapse-item title="ヤギにはがきを渡す"  v-if="false"
                            name="postcard">
            <div><router-link id="footer-link-postcard"
                         :to="{name: 'postCard'}"><img src="/static/img/postcard/postyagi.svg" alt="郵便ヤギ"><br>ヤギや運営へのひとことメッセージをお待ちしています</router-link></div>
          </el-collapse-item>

          <el-collapse-item title="スマホから履歴書を印刷するには"
                            name="print">
            <div>GoogleドライブやDropboxなどのクラウドストレージを使用するか、Gmail経由で自分宛てにPDFを送ってデータを保存します。印刷は自宅のプリンタまたはコンビニ印刷などをご利用下さい。</div>
            <div v-if="!$firebase.isAuthenticated">コンビニ印刷のサービスご利用には、ログイン(無料)が必要になります。</div>
            <ul class="collapse-list" v-if="$firebase.isAuthenticated">
              <li>
                <a id="pdf-eprint-edit"
                          type="success"
                          style="cursor:pointer;"
                          :disabled="!$deviceLib.isOnline"
                          @click="$eventHub.$emit('show-preview-4conv')">
                  セブンイレブン・ファミリーマート・ローソンなど - eプリント
                </a>
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="他の端末から続きを書くには"
                            name="backup">
            <div>他の端末から続きを編集したい場合は、Googleアカウントでログインし「バックアップをとる」でデータを保存して続きを書くことができます。なお、会員登録していない状態でも、現在入力されている端末からであれば続きの入力ができます（ブラウザのデータを削除したり、端末を変更した場合はリセットされます）。</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</div>
</template>
<style lang="scss" scoped>
.yagitaku{
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}
.yagitaku_recommend{
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}
.yagitaku_link{
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}
.create-date_bnr{
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
    color: #000;
    background: #EFF8F8;
    border: none;
    display: block;
    padding: 0;
    border-radius: 15px;
    white-space: normal;
    line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
 .el-button--primary.overwrite:hover{
    background: none;
    color: #000;
}
.addition {
  font-size: .75rem;
  margin: .5rem 0;
}
* {
	list-style: none;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}
img {
	width: 100%;
	vertical-align: bottom;
}

.next_bnr{
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
	display: flex;
	flex-wrap: wrap;
	margin: calc(-30px / 2);
	padding: 30px;
}
.bnr_itemWrapper {
	width: calc(100% / 2 - 30px);
	margin: calc(30px / 2);
}
.bnr_item {
  text-align: center;
}

.bnr_item img{
  border-radius: 10px 10px 0 0 ;
}

.bnr_txt{
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt{
  border-radius: 10px;
}

.bnr_txt p{
  font-size: 0.8rem;
  font-weight: bold;
  font-family: "M PLUS Rounded 1c";
}

.bnr_txt h3{
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span{
  font-size: 0.8rem;
}
.create-date_txt {
  border-radius: 10px;
}

.bnr_note{
  font-size: 0.8rem;
}


.card-header h1{
  padding-bottom: 1.5rem;
}
.card-header h2{
  padding-bottom: 1.5rem;
}
/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
	.bnr_itemWrapper {
		width: calc(100% / 2 - 30px);
	}
}
/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
	.bnr_itemWrapper {
		width: calc(100% / 1 - 30px);
	}
}

</style>

<script>
import HistoryItem from './RirekishoParts/HistoryItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginForms'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'RirekishoEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      saveName: 'rirekisho',
      activeName: '1',
      formatData: {
        createDate: null,
        educationalHistories: [],
        jobHistories: [],
        licenseHistories: [],
        commuteDescription: '',
        commuteHours: '',
        commuteMinutes: '',
        spouseNumber: '',
        hasSpouse: false,
        underDutyToSupport: false,
        reason: '',
        reasonNew: '',
        request: '',
        nowNensyu: '',
        kibouNensyu: ''
      },
      activeHistoryItem: '',
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isNew: false,
      textareaMinRows: 3,
      reasonLabel: '志望動機、特技、好きな学科、アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
      downloadActiveCollapses: ['postcard'],
      gradeYearOptions: [
        {
          value: '23',
          label: '23年卒'
        },
        {
          value: '24',
          label: '24年卒'
        },
        {
          value: '99',
          label: 'その他'
        }
      ],
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    setEducationalBackgrounds: function (historyList) {
      this.formatData.educationalHistories = []
      // 常に先頭から追加
      let index = 0
      for (let key in historyList) {
        let item = historyList[key]
        this.addEducationalHistory(index++, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    addExampleSentences: function (selectedSentences, modal) {
      let tArea = this.$refs.yourTextarea
      let startPos = tArea.selectionStart
      let endPos = tArea.selectionEnd
      let tmpStr = tArea.value
      console.error(tArea)
      console.error(startPos)
      this.formatData.reasonNew = tmpStr.substring(0, startPos) + selectedSentences + tmpStr.substring(endPos, tmpStr.length)
      modal.hide('reason-dialog')
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (let key in historyList) {
        let item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetEducationalBackgrounds: function () {
      this.formatData.educationalHistories = []
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new HistoryData(columns.year, columns.month, columns.description)
    },
    addHistory: function (historyList, index, refId, columns) {
      const newHistoryItem = this.createHistoryItem(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    addEducationalHistory: function (index, columns) {
      this.addHistory(this.formatData.educationalHistories, index, 'EducationalHistory_', columns)
    },
    moveEducationalHistory: function (params) {
      this.moveHistory(this.formatData.educationalHistories, params)
    },
    addJobHistory: function (index, columns) {
      this.addHistory(this.formatData.jobHistories, index, 'JobHistory_', columns)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    addLicenseHistory: function (index, columns) {
      this.addHistory(this.formatData.licenseHistories, index, 'LicenseHistory_', columns)
    },
    moveLicenseHistory: function (params) {
      this.moveHistory(this.formatData.licenseHistories, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteEducationalHistory: function (index) {
      this.formatData.educationalHistories.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteLicenseHistory: function (index) {
      this.formatData.licenseHistories.splice(index, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    if (this.formatId === 'rirekisho_job_new') {
      this.textareaMinRows = 10
      this.reasonLabel = '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう'
    }
    if (this.formatId === 'rirekisho_job_new_single') {
      this.textareaMinRows = 6
      this.reasonLabel = '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう'
    }
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
  }
}
</script>
